import * as React from "react";
import type { SelectProps } from "antd";
import { Select } from "antd";

const options: SelectProps["options"] = [];

for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}

interface MultiSelectProps {
  options: { label: string; value: string }[];
  value: string[];
  disabled?: boolean;
}

export const MultiSelect: React.FC<MultiSelectProps> = ({ options, value, disabled = true }) => {
  // Auto-select all options by default
  const allValues = options.map((o) => o.value);
  return (
    <Select
      mode="multiple"
      disabled={disabled}
      style={{ width: '100%', textAlign:"center" }}
      placeholder="Select communities"
      value={allValues}
      options={options}
      className="w-full text-center disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
      optionFilterProp="label"
    />
  );
};


